import UsersPage from ".";

export default {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: "/users",
      component: UsersPage
    }
  ]
};



// WEBPACK FOOTER //
// ./src/main/content/project/users/usersConfig.js